// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { useMemo } from 'react';

import type { CaseActions, CaseData } from '../../../app/bygning/useCaseData';
import type { FilteredResources } from '../../../bygning/resourceFilter';
import { roomsOf } from '../../../bygning/rooms';
import type { Selection } from '../../../bygning/selection';
import { ResourceFilters } from '../ResourceFilters';
import { TableViewSwitch } from '../TableViewSwitch';
import { useStoreys } from '../settings/SettingsContext';
import { PartsTable } from './PartsTable';
import styles from './Tabel.module.css';
import { TypesTable } from './TypesTable';

export interface TabelTileProps {
  data: CaseData;
  sel: Selection;
  setSel: (patch: Partial<Selection>) => void;
  actions: CaseActions;
  /** The filtered set (`filterResources`) both tables list, the same the Model's strip and Galleri show. */
  filtered: FilteredResources;
}

/**
 * Ressourcer's Tabel (`?view=tabel`): the two tables, with the Typer/Dele
 * toggle (`?tview=`) and the shared filters (`ResourceFilters`) leading
 * whichever toolbar is showing.
 */
export function TabelTile({ data, sel, setSel, actions, filtered }: TabelTileProps) {
  const storeys = useStoreys();
  const rooms = useMemo(() => roomsOf(data.types, data.summary), [data.types, data.summary]);
  const switcher = (
    <>
      <TableViewSwitch label="Tabel" value={sel.tview} onChange={(tview) => setSel({ tview })} />
      <ResourceFilters sel={sel} setSel={setSel} rooms={rooms} storeys={storeys} />
    </>
  );
  return (
    <div className={styles.tile}>
      {sel.tview === 'dele' ? (
        <PartsTable data={data} sel={sel} setSel={setSel} actions={actions} filtered={filtered} switcher={switcher} />
      ) : (
        <TypesTable data={data} sel={sel} setSel={setSel} actions={actions} filtered={filtered} switcher={switcher} />
      )}
    </div>
  );
}
